var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssethub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 225 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 225C174.632 225 225 174.632 225 112.5C225 50.368 174.632 0 112.5 0C50.368 0 0 50.368 0 112.5C0 174.632 50.368 225 112.5 225Z",
    fill: "#361C4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.22 91.94C61.1891 91.94 68.46 84.6691 68.46 75.7C68.46 66.7309 61.1891 59.46 52.22 59.46C43.2509 59.46 35.98 66.7309 35.98 75.7C35.98 84.6691 43.2509 91.94 52.22 91.94Z",
    fill: "#FC007B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 59.46C121.469 59.46 128.74 52.1891 128.74 43.22C128.74 34.2509 121.469 26.98 112.5 26.98C103.531 26.98 96.26 34.2509 96.26 43.22C96.26 52.1891 103.531 59.46 112.5 59.46Z",
    fill: "#FC007B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.77 91.94C182.739 91.94 190.01 84.6691 190.01 75.7C190.01 66.7309 182.739 59.46 173.77 59.46C164.801 59.46 157.53 66.7309 157.53 75.7C157.53 84.6691 164.801 91.94 173.77 91.94Z",
    fill: "#FC007B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.22 165.63C61.1891 165.63 68.46 158.359 68.46 149.39C68.46 140.421 61.1891 133.15 52.22 133.15C43.2509 133.15 35.98 140.421 35.98 149.39C35.98 158.359 43.2509 165.63 52.22 165.63Z",
    fill: "#FC007B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 198.1C121.469 198.1 128.74 190.829 128.74 181.86C128.74 172.891 121.469 165.62 112.5 165.62C103.531 165.62 96.26 172.891 96.26 181.86C96.26 190.829 103.531 198.1 112.5 198.1Z",
    fill: "#FC007B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.77 165.63C182.739 165.63 190.01 158.359 190.01 149.39C190.01 140.421 182.739 133.15 173.77 133.15C164.801 133.15 157.53 140.421 157.53 149.39C157.53 158.359 164.801 165.63 173.77 165.63Z",
    fill: "#FC007B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.14 72.45H97.87L68.51 138.24H93.5L98.21 126.95H126.82L131.53 138.24H156.52L127.16 72.45H127.14ZM112.98 109.58H104.42L112.51 90.63L120.6 109.58H112.98Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssethub);
export default __webpack_public_path__ + "static/media/assethub.acef18b7.svg";
export { ForwardRef as ReactComponent };